/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WbsPlanningDtoFromJSON, WbsPlanningDtoToJSON, } from './WbsPlanningDto';
/**
 * Check if a given object implements the WbsListDto interface.
 */
export function instanceOfWbsListDto(value) {
    return true;
}
export function WbsListDtoFromJSON(json) {
    return WbsListDtoFromJSONTyped(json, false);
}
export function WbsListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'titolo': json['titolo'] == null ? undefined : json['titolo'],
        'pesoAttivita': json['pesoAttivita'] == null ? undefined : json['pesoAttivita'],
        'corrispettivoEconomico': json['corrispettivoEconomico'] == null ? undefined : json['corrispettivoEconomico'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'wbsPlanningDtoList': json['wbsPlanningDtoList'] == null ? undefined : (json['wbsPlanningDtoList'].map(WbsPlanningDtoFromJSON)),
    };
}
export function WbsListDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'titolo': value['titolo'],
        'pesoAttivita': value['pesoAttivita'],
        'corrispettivoEconomico': value['corrispettivoEconomico'],
        'projectId': value['projectId'],
        'wbsPlanningDtoList': value['wbsPlanningDtoList'] == null ? undefined : (value['wbsPlanningDtoList'].map(WbsPlanningDtoToJSON)),
    };
}
